<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="证书名称" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="所属课程" prop="course_uuid">
            <!-- <el-tag>+</el-tag> -->
            <el-col :span="24">
              <el-button @click="cousebox = true">选择关联</el-button>
            </el-col>
            <el-col :span="24"
              >当前：
              <span>{{ couseSelect.title }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="证书类型" prop="type">
            <el-radio-group v-model="ruleForm.type">
              <el-radio :label="1">荣誉</el-radio>
              <el-radio :label="2">证书</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="证书模板" prop="template">
            <imgUpload v-model="ruleForm.template"> </imgUpload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="课程列表" :visible.sync="cousebox">
      <div class="search-bar">
        <el-input v-model="keyword_search" placeholder="输入关键字查询" clearable @clear="getCouseList"></el-input>
        <el-button type="primary" @click="getCouseList">查询</el-button>
        <el-button type="primary" @click="resetCouse">重置</el-button>
      </div>

      <el-table
        ref="multipleTable"
        highlight-current-row
        :data="couseList"
        height="50vh"
        @current-change="handleCchange"
      >
        <!-- <el-table-column
                    type="selection"
                    width="55"
                >
                </el-table-column> -->
        <el-table-column property="title" label="名称" width="200"></el-table-column>
        <el-table-column property="address" label="封面">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.cover"
              fit="contain"
              :preview-src-list="[scope.row.cover]"
            >
            </el-image>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[5, 10, 20, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div style="text-align: center">
        <el-button @click="cousebox = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import { addCertificate, editCertificate, certificateDetail, getCouseList } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
  },
  mixins: [mixin],
  data() {
    return {
      keyword_search: "",
      page_size: 5,
      cousebox: false,
      tableData: [],
      dates: [],
      loading: false,
      typeList: [],
      couseList: [],
      ruleForm: {
        course_uuid: "",
        type: 2,
      },
      couseSelect: this.$route.query.course || {},
      rules: {
        title: [
          {
            required: true,
            message: "请输入证书名称",
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: "请上传直播封面",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择证书类型",
            trigger: "change",
          },
        ],
        template: [
          {
            required: true,
            message: "请上传证书模板",
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入现价",
            trigger: "blur",
          },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        course_uuid: [
          {
            // type: 'array',
            required: true,
            message: "请选择关联课程",
            trigger: "change",
          },
        ],
        teacher_uuid: [
          {
            required: true,
            message: "请选择授课老师",
            trigger: "change",
          },
        ],
        desc: [
          {
            required: true,
            message: "请填写活动形式",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    console.log();
    const row = this.$route.query;
    if (row.uuid) {
      this.getDetail(row);
    }
    this.getCouseList("");
  },
  methods: {
    resetCouse() {
      this.keyword_search = "";
      this.page_index = 1;
      this.getCouseList();
    },
    handleCchange(val) {
      console.log(val);
      this.couseSelect = val;
      if (val) {
        this.ruleForm.course_uuid = val.uuid;
      }
    },
    async getDetail(row) {
      const res = await certificateDetail(row.uuid);

      if (res) {
        if (res.cate instanceof Array) {
          res.cate_uuid = res.cate.map((it) => {
            return it.uuid;
          });
        }
        // if (res.banner) {
        //     if (!Array.isArray(res.banner)) {
        //         res.banner = JSON.parse(res.banner)
        //     }
        // }
        this.ruleForm = {
          ...res,
        };
        console.log(res);
      }
    },
    getType() {
      getLiveType().then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    getList() {
      this.getCouseList();
    },
    getCouseList() {
      getCouseList({
        keyword_search: this.keyword_search,
        page_index: this.page_index,
        page_size: this.page_size,
      }).then((res) => {
        if (res.data instanceof Array) {
          this.couseList = res.data;
          this.total = res.total;
        }
      });
    },
    editSave(data, uuid) {
      editCertificate(data, uuid).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("编辑成功");

          this.$router.go(-1);
        }
      });
    },
    addSave(data) {
      addCertificate(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("新增成功");

          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            course_uuid: this.couseSelect.uuid,
          };
          if (this.ruleForm.uuid) {
            this.editSave(data, this.ruleForm.uuid);
          } else {
            this.addSave(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
</style>
